import { cartApi } from '@api/cart.api';
import { LineItemData } from '@api/types';
import { createSlice, createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/store';

// INITIAL STATE
export type AppState = {
  lineItems: LineItemData[];
};

const initialState: AppState = {
  lineItems: [],
};

// REDUCERS
export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(cartApi.endpoints.getCurrentCart.matchFulfilled, (state, action) => {
      state.lineItems = action.payload.data?.lineItems || [];
    });
  },
});

// ACTIONS

// SELECTORS
export const getCartItems = createSelector(
  (state: RootState) => state.cart.lineItems,
  (items) => items
);

export const getCartTotalItems = createSelector(getCartItems, (items) =>
  items.map((x) => x.quantity || 0).reduce((total, value) => total + value, 0)
);

export const getCartQuantity = (code: string) =>
  createSelector(getCartItems, (items) => items.find((item) => item.code === code)?.quantity || 0);

export default cartSlice.reducer;
